import moment from "moment";
import { DateType } from "./format";

/**
 * 날짜 구하기
 * @history  최근 30일에서 최근 3개월로 변경됨
 * @param targetDate
 * @param days
 * @returns
 */
export const calcDates = (targetDate: DateType, days: number) =>
  moment(targetDate).isValid()
    ? moment(targetDate).add(days, "months")
    : undefined;
